// extracted by mini-css-extract-plugin
export var box = "_3r-2";
export var checkboxControl = "_3r-0";
export var checkboxRow = "_3r-a";
export var checked = "_3r-3";
export var descriptionSpacer = "_3r-c";
export var disabled = "_3r-4";
export var icon = "_3r-8";
export var input = "_3r-1";
export var labelSpacer = "_3r-b";
export var large = "_3r-7";
export var medium = "_3r-6";
export var small = "_3r-5";
export var text = "_3r-9";